import { createFileRoute } from '@tanstack/react-router'
import { Companies } from '../../components/Companies/Companies'

export const Route = createFileRoute('/_layout/companies')({
  component: Companies,
})
